/** Monthly payment for a fixed-rate loan fully amortised over `years`. */
export function monthlyPayment(
  principal: number,
  annualRate: number,
  years: number,
): number {
  const r = annualRate / 12;
  const n = years * 12;
  if (n <= 0 || principal <= 0) return 0;
  if (r === 0) return principal / n;
  return (principal * (r * (1 + r) ** n)) / ((1 + r) ** n - 1);
}

/** Principal left after `paymentsMade` monthly payments. */
export function remainingBalance(
  principal: number,
  annualRate: number,
  years: number,
  paymentsMade: number,
): number {
  const n = years * 12;
  if (principal <= 0 || paymentsMade >= n) return 0;
  if (paymentsMade <= 0) return principal;
  const r = annualRate / 12;
  if (r === 0) return principal * (1 - paymentsMade / n);
  const payment = monthlyPayment(principal, annualRate, years);
  return (
    principal * (1 + r) ** paymentsMade -
    (payment * ((1 + r) ** paymentsMade - 1)) / r
  );
}
